const styles = {
  header: {
    backgroundColor: '#fff !important',
    margin: '0 0 1.875em 0  !important',
    width: '100%  !important',
    border: 'solid 1px #f5f6f7 !important',
    position: 'fixed !important',
    top: '0 !important',
  },
  container: {
    alignItems: 'center !important',
    height: '4.96875em  !important',
    margin: '0 4.8125em  !important',
    padding: '0 !important',
  },
  logo: {
    display: 'flex  !important',
    alignContent: 'center  !important',
    height: '2.5rem !important',
    width: '2.5rem !important',
  },
  merchantDetails: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',

    '& > div': {
      display: 'flex',
      marginLeft: 'auto !important',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  datePicker: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',

    '&& > div': {
      marginRight: '0 !important',
    },
  },
  reportReturnCTA: {
    display: 'flex',
    alignItems: 'center',
    margin: '.500rem 0',
  },
};

export default styles;
